import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useVerifyEmailMutation } from "../../services/authAPI";
import {
  English,
  French,
  German,
  Dutch,
  Spanish,
  Italian,
  Romanian,
  Portuguese,
} from "../../dictionary/LoginText";
import { LanguageCheck } from "../../utils/LanguageCheck";
import { selectLanguage } from "../../features/user/userSlice";
import { useAppSelector } from "../../app/hooks";
import { getPostLoginRedirect, clearRedirectURL } from "../../utils/RouteUtils";

function LinkVerifyEmail() {
  const [message, setMessage] = useState<string>();
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const stateLang = useAppSelector(selectLanguage);
  let [language, setLanguage] = useState(
    LanguageCheck(
      English,
      French,
      German,
      Dutch,
      Spanish,
      Italian,
      Romanian,
      Portuguese,
      stateLang,
    ),
  );

  useEffect(() => {
    setLanguage(
      LanguageCheck(
        English,
        French,
        German,
        Dutch,
        Spanish,
        Italian,
        Romanian,
        Portuguese,
        stateLang,
      ),
    );
  }, [stateLang]);

  //Setting up the 2 queries
  const [
    sendVerifyCode,
    {
      data: verifyCodeData,
      error: verifyCodeError,
      isError: verifyCodeIsError,
      isSuccess: verifyCodeIsSuccess,
      isLoading: verifyCodeIsLoading,
    },
  ] = useVerifyEmailMutation();

  //If the user has entered the correct code for their email, redirect them to the login page
  useEffect(() => {
    if (verifyCodeData !== undefined) {
      if (verifyCodeIsSuccess && verifyCodeData.verifiedEmail) {
        toast.success(language.verifyEmail.toasts.verifyEmail);
        const redirectPath = getPostLoginRedirect();
        // Clear redirectURL after using it (it's a temporary redirect)
        if (localStorage.getItem("redirectURL")) {
          clearRedirectURL();
        }
        navigate(redirectPath);
      }
    }
  }, [verifyCodeIsSuccess]);

  //If the user has entered the wrong code for their email, show an error on the page
  useEffect(() => {
    if (verifyCodeIsError) {
      toast.error(language.linkVerifyEmail.toasts.invalidCode, {
        autoClose: 6000,
      });
      navigate("/verifyemail");
    }
  }, [verifyCodeIsError]);

  useEffect(() => {
    if (searchParams.get("token") !== null) {
      sendVerifyCode(searchParams.get("token") ?? "");
    } else {
      toast.error(language.linkVerifyEmail.toasts.invalidCode, {
        autoClose: 6000,
      });
      navigate("/verifyemail");
    }
  }, []);

  return (
    <div className="w-full h-screen flex items-center justify-center">
      {language.linkVerifyEmail.body.ifYouAreNotRedirected}&nbsp;
      <Link className="text-blue-600 hover:text-blue-700 underline" to="/">
        {language.linkVerifyEmail.body.here}
      </Link>
    </div>
  );
}

export default LinkVerifyEmail;
